import { AptOrderStatus } from '../../../common/enums/apttus/apt-order-status';
import { AptQuoteStatus } from '../../../common/enums/apttus/apt-quote-status';
import { AptQuoteSubStatus } from '../../../common/enums/apttus/apt-quote-sub-status';
import { AptSalesInadmissibilityProcess, AptSalesProcess } from '../../../common/enums/apttus/apt-sales-process';
import { AptCommodityType, FilterCommodityType } from './../../../common/enums/apttus/apt-commodity-typeof-sale';
import { BoCommonFilters } from './bo-common-filters';
import { BoFilterByDate } from './bo-filter-by-date';
import { BoSearchByField } from './bo-search-by-field';

export class MonitoraggioConditions extends BoCommonFilters {
    status?: AptQuoteStatus[];
    substatus?: AptQuoteSubStatus[];
    statusOrder?: AptOrderStatus[];
    date?: BoFilterByDate;
    orderBy?: string;
    searchByField?: BoSearchByField;
    commodityFilter?: AptCommodityType;
    constructor(applyDefault?: boolean) {
        super();
        this.date = new BoFilterByDate(applyDefault);
    }
}

export interface MonitoraggioFilters {
    conds: MonitoraggioConditions;
    operativeMode: AptSalesProcess;
    macroOperativeMode?: string;
    inamissibilityMode?: AptSalesInadmissibilityProcess;
    commodityType?: FilterCommodityType;
}
